import { LicenceUploadInfo } from './LicenceUploadInfo';
export class LicenceUploadPayload {
    public licenceDoc: any;
    public licenceInfo: LicenceUploadInfo = new LicenceUploadInfo();
  }
